import { Button } from 'components/Blocks/Buttons';

import { cn } from 'styles';

interface ClearButtonProps {
  children?: never;
  className?: string;
  onClick: () => void;
}

function ClearButton({ onClick, className }: ClearButtonProps): JSX.Element {
  return (
    <Button
      size="small"
      variant="ghost"
      type="button"
      className={cn('h-auto px-2 py-1 text-xs', className)}
      onClick={onClick}
    >
      Clear
    </Button>
  );
}

export default ClearButton;
